import axios from "axios";
import { baseUrl } from "../Common/Constants";
import httpClient from "../Core/http";

class MdcApi {
    fetchHeaders(series:any){
        let url =  "mdc/headers";

          const terms = JSON.stringify(series) 
    
          const queryObject = {
                terms: terms,
          }
          
        return httpClient.get(url, { params: queryObject }).then((response) => {
            return response.data;
        })
            .catch((error) => {
                throw error;
                console.log(error);
            });
    
    }

    fetchUnits(params: any): Promise<any> {
        let url = "mdc/units";
        return httpClient
            .get(url, { params: params })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return Promise.reject();
            });
    }

    fetchUniqueUnits(): Promise<any> {
        let url = "mdc/uniqueUnits";
        return httpClient
            .get(url)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return Promise.reject();
            });
    }

    fetchData(params:any){
        let url =  "mdc/mdcdata";

        const termsObj = {
            seriesObjects:params.seriesObjects
        }
        const terms = JSON.stringify(termsObj)

        const queryObject = {
            start: params.start,
            end: params.end,
            terms: terms,
        }
    return httpClient.get(url, { params: queryObject }).then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
            console.log(error);
        });

    }
}


export const mdcApi = new MdcApi();